import React, { createContext, useContext, useMemo } from 'react';

type StudentPeopleNavigationContextValue = {
  navigateToProfile: () => void;
  navigateToConnections: () => void;
};

const StudentPeopleNavigationContext = createContext<StudentPeopleNavigationContextValue | null>(null);

type ProviderProps = {
  children: React.ReactNode;
  navigationRef: React.RefObject<{ navigate: (name: string) => void } | null>;
};

/**
 * Bridges UserMenu (outside Stack.Navigator) to student account routes.
 */
export function StudentPeopleNavigationProvider({ children, navigationRef }: ProviderProps) {
  const value = useMemo(
    () => ({
      navigateToProfile: () => navigationRef.current?.navigate('PeopleProfile'),
      navigateToConnections: () => navigationRef.current?.navigate('MyConnections'),
    }),
    [navigationRef],
  );

  return (
    <StudentPeopleNavigationContext.Provider value={value}>
      {children}
    </StudentPeopleNavigationContext.Provider>
  );
}

export function useStudentPeopleNavigation(): StudentPeopleNavigationContextValue | null {
  return useContext(StudentPeopleNavigationContext);
}
